<template>

  <v-container fluid class="px-10 pt-8 pb-10 order-supporting-documents">

    <!-- (data loading spinner) -->
    <v-container class="d-flex flex-column align-center justify-center" v-if="isDataLoading">
      <v-progress-circular indeterminate :size="50" style="margin:20px 0" color="primary" />
    </v-container>

    <template v-else>
      <!-- Supporting Docs submitted with RouteLeaf Order -->
      <div class="title">
        Supporting Documents <span v-if="docCount > 0">({{ docCount }})</span>
      </div>

      <!-- Re-upload action -->
      <v-row class="mb-4 mt-6" v-if="canReupload">
        <v-col align="center">
          <reupload-order-documents
              docType="supporting"
              buttonText="Change Supporting Docs"
              :order="order"
              @uploading="isDataUpdating = true"
              @success="completeDocChanges"
              @failure="completeDocChanges" />
        </v-col>
      </v-row>

      <!-- Rendered supporting docs -->
      <template v-if="!isDataUpdating">
        <template v-if="sortedDocs && sortedDocs.length > 0">
          <div class="mt-10 doc-container" v-for="(docInfo, index) in sortedDocs" :key="index">
            <div class="mb-4 file-label">{{ docInfo.label }}</div>
            <div class="file-preview-container">
              <embed style="border:2px solid #525252;" :src="docInfo.url" width="85%" height="800" />
            </div>
          </div>
        </template>

        <!-- (no docs) -->
        <v-row class="mt-6" v-else>
          <v-col align="center">
            <span>(No supporting docs)</span>
          </v-col>
        </v-row>
      </template>
    </template>

  </v-container>

</template>

<script>
import ReuploadOrderDocuments from '@/components/orders/ReuploadOrderDocuments'

export default {
  name: 'OrderSupportingDocuments',

  components: {
    ReuploadOrderDocuments
  },

  data () {
    return {
      docs: [],
      orderIdForAssets: null,
      isDataLoading: false,
      isDataUpdating: false,
      isSupportingDocsDialogOpen: false,
      newSupportingDocs: null
    }
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    uiType () {
      return this.$root.uiType()
    },
    sortedDocs () {
      return this.$root.utils.sortBy(this.docs, ['order'])
    },
    docCount () {
      return this.docs.length
    },
    canReupload () {
      return (
        this.uiType === 'shipper' &&
        this.order.order_status !== 'RESCHEDULED' &&
        this.order.order_status !== 'REJECTED_ON_DELIVERY' &&
        (this.$root.activeUserHasRole('admin') || this.$root.activeUserHasRole('dispatcher'))
      )
    }
  },

  async beforeMount () {
    // Load order ID for assets
    this.orderIdForAssets = (this.order.root_order_id) ? this.order.root_order_id : this.order.id

    // Load supporting docs for display
    this.loadSupportingDocs()
  },

  methods: {
    async loadSupportingDocs () {
      const docInfo = this.order.supporting_docs || {}
      const assets = Object.entries(docInfo)

      this.isDataLoading = true

      for (const [key, data] of assets) {
        const url = await this.$root.fetchOrderAsset(this.orderIdForAssets, key)
        this.docs.push({ ...data, url })
      }

      this.isDataLoading = false
    },

    completeDocChanges (results) {
      this.isDataUpdating = false
      this.$parent.reloadOrderData() // reload order
    }
  }
}
</script>

<style scoped>
  .order-supporting-documents .doc-container {
    min-height: 150px;
    text-align: center;
  }

  .order-supporting-documents .file-label {
    text-align: left;
    font-size: 1.2em;
    font-style: italic;
  }

  .order-supporting-documents .file-preview-container {
    text-align: center;
  }
</style>
